<div class="avatars">
    <app-avatar class="avatar" *ngFor="let avatar of firstN" [size]="size" [imageOnly]="true" [fxInline]="true"
        [avatar]="avatar" [bordered]="true" [hoverEffect]="true">
    </app-avatar>
    <span [style.height]="size" [style.width]="size" class="avatars-hidden" *ngIf="restCount">
        <span> {{restCount }}</span>
    </span>
</div>
